import React, { cloneElement, isValidElement } from 'react';
import { ArrowDown, ArrowUp, IconContext } from '@phosphor-icons/react';
import { OverflowWrapper } from 'app/components';
import { format } from 'date-fns';

const Row = (props) => {
  const {
    column,
    row,
    index,
    actionItems,
    onClickActionItem,
  } = props;

  if (column?.field === 'action_items') {
    return (
      <div className="row-container action-items-list flex gap-2">
        {actionItems?.map((item) => (
          <IconContext.Provider value={{ color: '#878787', size: 20, ...item?.iconProps }}>
            <div
              className="action-icon cursor-pointer"
              onClick={() => onClickActionItem(item, row, index)}
            >
              {item?.icon}
            </div>
          </IconContext.Provider>
        ))}
      </div>
    )
  }

  if (column?.rowElement) {
    if (isValidElement(column.rowElement)) return cloneElement(column.rowElement, { column, row, index });

    const Element = column?.rowElement;

    return <Element {...{ column, row, index }} />;
  }

  if (column?.isDate) {
    const dateValue = row?.[column?.field] ? format(new Date(row?.[column?.field]), column?.dateFormat || 'do LLL yyyy, hh:mm a') : '-';

    return (
      <div className="row-container">
        <OverflowWrapper>{dateValue}</OverflowWrapper>
      </div>
    );
  }

  return (
    <div className="row-container">
      <OverflowWrapper>
        {row?.[column?.field]}
      </OverflowWrapper>
    </div>
  );
};

export default Row;